import { useState, useCallback, useMemo } from "../../../__compat__/react/main.entry.mjs.mjs";
import { isSameDay, isAfter, isWithinInterval, } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { isRange, isStart, isEnd, shouldSelectStart, shouldSelectEnd, } from "../dateHelpers.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
export function useCalendarSelection(selection = null, onSelectionChange = () => { }) {
    const { localeIdentifier, datePicker: locale } = useLocale();
    const [hovered, setHovered] = useState(null);
    const { format: formatDate } = useMemo(() => new Intl.DateTimeFormat(locale.dateLocale || localeIdentifier, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }), [localeIdentifier, locale.dateLocale]);
    const getAriaLabel = (date) => {
        const localizedDate = formatDate(date);
        return localizedDate;
    };
    const handleMouseEnter = (date) => setHovered(date);
    const handleMouseLeave = () => setHovered(null);
    const handleSelection = useCallback((date) => {
        if (isRange(selection)) {
            if (shouldSelectStart(selection, date))
                onSelectionChange([date, null]);
            else if (shouldSelectEnd(selection))
                onSelectionChange([selection[0], date]);
        }
        else {
            onSelectionChange(date);
        }
    }, [selection, onSelectionChange]);
    const getSelectionProps = (date) => {
        var _a, _b;
        return ({
            'aria-label': getAriaLabel(date),
            onMouseEnter: () => handleMouseEnter(date),
            onMouseLeave: () => handleMouseLeave(),
            ...(isRange(selection)
                ? {
                    selected: isStart(selection, date) || isEnd(selection, date),
                    selectedRange: selection[0] !== null &&
                        (selection[1] !== null || hovered !== null) &&
                        isAfter((_a = selection[1]) !== null && _a !== void 0 ? _a : hovered, selection[0]) &&
                        isWithinInterval(date, {
                            start: selection[0],
                            end: (_b = selection[1]) !== null && _b !== void 0 ? _b : hovered,
                        }),
                }
                : {
                    selected: selection !== null && isSameDay(selection, date),
                }),
        });
    };
    return {
        handleSelection,
        getSelectionProps,
    };
}
//# sourceMappingURL=useCalendarSelection.mjs.mjs.map